/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_WarehouseInputs */

const en_role_warehouse = /** @type {(inputs: Role_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse`)
};

const es_role_warehouse = /** @type {(inputs: Role_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacen`)
};

/**
* | output |
* | --- |
* | "Warehouse" |
*
* @param {Role_WarehouseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const role_warehouse = /** @type {((inputs?: Role_WarehouseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_WarehouseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_warehouse(inputs)
	return es_role_warehouse(inputs)
});